import React from 'react';
import { Slider } from '@/components/ui/slider';

interface HookTrackCardProps {
  intro: {
    id: string;
    name: string;
    thumbnail: string;
  };
  index: number;
  percentage: number;
  onPercentageChange: (introId: string, newPercentage: number) => void;
}

export function HookTrackCard({ intro, index, percentage, onPercentageChange }: HookTrackCardProps) {
  return (
    <div
      className="relative bg-card border rounded-xl overflow-hidden border-border hover:border-[#1D4FFF] transition-all duration-200 ease-out"
    >
      {/* Thumbnail with Name Overlay */}
      <div className="relative aspect-video w-full bg-muted">
        {/* Badge número no canto superior esquerdo */}
        <div className="absolute top-2.5 left-2.5 z-[3] bg-[#1D4FFF] text-white text-[11px] font-bold px-2 py-1 rounded">
          #{index + 1}
        </div>
        <img
          src={intro.thumbnail}
          alt={intro.name}
          className="w-full h-full object-cover"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
          <h3 className="font-medium text-sm text-white truncate">{intro.name}</h3>
        </div>
      </div>

      {/* Percentage + Slider */}
      <div className="p-4 flex items-center gap-4">
        <span className="text-[#6B7280] font-semibold text-base min-w-[40px]">{percentage}%</span>
        <Slider
          value={[percentage]}
          min={0}
          max={100}
          step={1}
          onValueChange={(value) => onPercentageChange(intro.id, value[0])}
          className="flex-1"
        />
      </div>
    </div>
  );
}
